// Полоса дней (MatchCenterDateStrip iOS): вкладки-подчёркивания, выбранный день — по центру полосы.
import { useLayoutEffect, useMemo, useRef } from 'react';
import { dateLocale, t } from '../../i18n/i18n';
import { haptic } from '../../telegram/webapp';
import { dayDiff, dayLabel, dayStrip } from './days';
import styles from './MatchCenter.module.css';

export function DayStrip({ today, selected, onSelect }: { today: string; selected: string; onSelect: (day: string) => void }) {
  const days = useMemo(() => dayStrip(today, selected), [today, selected]);
  const words = useMemo(() => ({ today: t('matchCenter.today'), yesterday: t('matchCenter.yesterday'), tomorrow: t('matchCenter.tomorrow') }), []);
  const ref = useRef<HTMLDivElement>(null);
  useLayoutEffect(() => {
    const strip = ref.current;
    const el = strip?.querySelector<HTMLElement>(`[data-day="${selected}"]`);
    if (!strip || !el) return;
    strip.scrollLeft = el.offsetLeft - (strip.clientWidth - el.offsetWidth) / 2;
  }, [selected, days]);
  return (
    <nav className={styles.strip} aria-label={t('matchCenter.days')}>
      <div className={styles.days} ref={ref} role="tablist">
        {days.map((day) => (
          <button key={day} role="tab" data-day={day} aria-selected={day === selected}
            className={`${styles.day} ${Math.abs(dayDiff(today, day)) <= 1 ? styles.named : ''} ${day === selected ? styles.daySelected : ''}`}
            onClick={() => { if (day !== selected) { haptic.selection(); onSelect(day); } }}>
            {dayLabel(day, today, words, dateLocale)}
          </button>
        ))}
      </div>
    </nav>
  );
}
